import React from "react";
import { Modal, Button, IconWarningAlt } from "@veneer/core";

interface ExitEvaluationModalProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  t: (key: string) => string;
}

export const ExitEvaluationModal: React.FC<ExitEvaluationModalProps> = ({
  show,
  onClose,
  onConfirm,
  t,
}) => {
  return (
    <Modal
      className="exitEvaluationModal"
      show={show}
      onClose={onClose}
      align="center"
      title={t("modal.warningTitle")}
    >
      <IconWarningAlt size={120} />

      <p>{t("header.exitAlert")}</p>

      <div className="modalActions">
        <Button appearance="secondary" onClick={onClose}>
          {t("header.cancel")}
        </Button>

        <Button appearance="primary" onClick={onConfirm}>
          {t("header.yes")}
        </Button>
      </div>
    </Modal>
  );
};
